var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoDownloadInvoice = function SvgIcoDownloadInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.5h3.75L8 10 3.5 5.5h3.75V.25h1.5zM2 12.25h12V7h1.5v6a.75.75 0 0 1-.75.75H1.25A.75.75 0 0 1 .5 13V7H2z"
  })));
};
export default SvgIcoDownloadInvoice;